/*!

 =========================================================
 * Bootstrap Wizard - v1.1.1
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/bootstrap-wizard
 * Copyright 2017 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/bootstrap-wizard/blob/master/LICENSE.md)
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// Get Shit Done Kit Bootstrap Wizard Functions

searchVisible = 0;
transparent = true;

$(document).ready(function() {
  /*  Activate the tooltips      */
  $('[rel="tooltip"]').tooltip();

  if ($(".wizard-card #register-step-0").length) {
    // Code for the Validator
    var $validator0 = $(".wizard-card #register-step-0").validate({
      rules: {
        name: {
          required: true,
          minlength: 3
        },
        surname: {
          required: true,
          minlength: 3
        },
        mobile_phone: {
          required: true,
          minlength: 8
        },
        password: {
          required: true,
          minlength: 6
        },
        password_confirmation: {
          equalTo: "#password"
        },
        email: {
          required: true,
          minlength: 3,
          email: true,
          remote: {
            type: "GET",
            url: "/checkEmailAvailability",
            data: {
              email: function() {
                return $("#register-step-0 input[name='email']").val();
              }
            }
          }
        }
      },
      messages: {
        email: {
          remote: "Email already in use!"
        }
      }
    });

    $display_width = $(document).width();

    if ($display_width <= 767) {
      $(".about_text").text(function() {
        return "About";
      });
    }

    // Wizard Initialization
    $(".wizard-card").bootstrapWizard({
      tabClass: "nav nav-pills",
      nextSelector: ".btn-next",
      lastSelector: ".btn-finish",
      previousSelector: ".btn-previous",
      skipSelector: ".btn-skip",

      onNext: function(tab, navigation, index) {
        var $valid = $(".wizard-card #register-step-0").valid();
        if (!$valid) {
          $validator0.focusInvalid();
          return false;
        } else {
          if ($("#register-step-0").length > 0) {
            // $("#register-step-0").submit();
            
          }
        }
      },

      onLast: function(tab, navigation, index) {
        var $valid1 = $(".wizard-card #register-step-0").valid();
        if (!$valid1) {
          $validator0.focusInvalid();
          return false;
        } else {
          if ($("#register-step-0").length > 0) {
            // $("#register-step-0").submit();
          }
        }
      },

      onInit: function(tab, navigation, index) {
        //check number of tabs and fill the entire row
        var $total = navigation.find("li").length;
        $width = 100 / $total;
        var $wizard = navigation.closest(".wizard-card");

        if ($display_width < 600 && $total > 3) {
          $width = 50;
        }

        navigation.find("li").css("width", $width + "%");
        $first_li = navigation.find("li:first-child a").html();
        $moving_div = $('<div class="moving-tab">' + $first_li + "</div>");
        $(".wizard-card .wizard-navigation").append($moving_div);
        refreshAnimation($wizard, index);
        $(".moving-tab").css("transition", "transform 0s");
      },

      onTabShow: function(tab, navigation, index) {
        var $total = navigation.find("li").length;
        var $current = index + 1;

        var $wizard = navigation.closest(".wizard-card");
        if ($current == 2) {
          $(".btn-next.btn-fill").val("Next");
        }
        // If it's the last tab then hide the last button and show the finish instead
        if ($current >= $total) {
          $($wizard)
            .find(".btn-next")
            .hide();
          $($wizard)
            .find(".btn-finish")
            .show();
        } else {
          $($wizard)
            .find(".btn-next")
            .show();
          $($wizard)
            .find(".btn-finish")
            .hide();
        }

        button_text = navigation
          .find("li:nth-child(" + $current + ") a")
          .html();

        setTimeout(function() {
          $(".moving-tab").text(button_text);
        }, 150);

        var checkbox = $(".footer-checkbox");

        if (!index == 0) {
          $(checkbox).css({
            opacity: "0",
            visibility: "hidden",
            position: "absolute"
          });
        } else {
          $(checkbox).css({
            opacity: "1",
            visibility: "visible"
          });
        }

        refreshAnimation($wizard, index);
      }
    });

    // Prepare the preview for profile picture
    $("#wizard-picture").change(function() {
      readURL(this);
    });

    $('[data-toggle="wizard-radio"]').click(function() {
      wizard = $(this).closest(".wizard-card");
      wizard.find('[data-toggle="wizard-radio"]').removeClass("active");
      $(this).addClass("active");
      $(wizard)
        .find('[type="radio"]')
        .removeAttr("checked");
      $(this)
        .find('[type="radio"]')
        .attr("checked", "true");
    });

    $('[data-toggle="wizard-checkbox"]').click(function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
          .find('[type="checkbox"]')
          .removeAttr("checked");
      } else {
        $(this).addClass("active");
        $(this)
          .find('[type="checkbox"]')
          .attr("checked", "true");
      }
    });

    $(".set-full-height").css("height", "auto");
  }

  if (
    $(".wizard-card #register-step1").length ||
    $(".wizard-card #register-step-last").length
  ) {
    // Code for the Validator
    var $validator1 = $(".wizard-card #register-step1").validate({
      rules: {
        name: {
          required: true,
          minlength: 3
        },
        surname: {
          required: true,
          minlength: 3
        },
        password: {
          required: true,
          minlength: 6
        },
        password_confirmation: {
          equalTo: "#password"
        },
        email: {
          required: true,
          minlength: 3,
          email: true,
          remote: {
            type: "GET",
            url: "/checkEmailAvailability",
            data: {
              email: function() {
                return $("#register-step1 input[name='email']").val();
              }
            }
          }
        }
      },
      messages: {
        email: {
          remote: "Email already in use!"
        }
      }
    });

    // Code for the Validator
    var $validator2 = $(".wizard-card #register-step-last").validate({
      ignore:
        ":hidden:not([class~=selectized]),:hidden > .selectized, .selectize-control .selectize-input input",
      rules: {
        name: {
          required: true
        },
        city_town: {
          required: true
        },
        county: {
          required: true
        },
        postcode: {
          required: true
        },
        dob_day: {
          required: true
        },
        dob_month: {
          required: true
        },
        dob_year: {
          required: true
        },
        short_description: {
          required: true
        },
        base_price: {
          required: true
        },
        "event_types[]": "required",
        "categories[]": "required",
        categories: {
          required: true
        },
        event_types: {
          required: true
        },
        image: {
          required: true,
          accept: "image/*"
        },
        contractInput: {
          required: true
        }
      }
    });

    $display_width = $(document).width();

    if ($display_width <= 767) {
      $(".about_text").text(function() {
        return "About";
      });
    }

    // Wizard Initialization
    $(".wizard-card").bootstrapWizard({
      tabClass: "nav nav-pills",
      nextSelector: ".btn-next",
      lastSelector: ".btn-finish",
      previousSelector: ".btn-previous",
      skipSelector: ".btn-skip",

      onNext: function(tab, navigation, index) {
        if (index == 1) {
          var $valid = $(".wizard-card #register-step1").valid();
          if (!$valid) {
            $validator1.focusInvalid();
            return false;
          } else {
            if (
              $("#register-step1").length > 0 &&
              check_if_capcha_is_filled_gdsk()
            ) {
              $("#register-step1").submit();
            } else {
              return false;
            }
          }
        } else {
          var $valid = $(".wizard-card #register-step-last").valid();
          if (!$valid) {
            $validator2.focusInvalid();
            return false;
          }
        }
      },

      onLast: function(tab, navigation, index) {
        var $valid2 = $(".wizard-card #register-step1").valid();
        if (!$valid2) {
          $validator2.focusInvalid();
          return false;
        } else {
          if (
            $("#register-step1").length > 0 &&
            check_if_capcha_is_filled_gdsk()
          ) {
            $("#register-step1").submit();
            console.log(3);
            // window.location.reload();
            return true;
          } else {
            return false;
          }
        }
      },

      onInit: function(tab, navigation, index) {
        //check number of tabs and fill the entire row
        var $total = navigation.find("li").length;
        $width = 100 / $total;
        var $wizard = navigation.closest(".wizard-card");

        if ($display_width < 600 && $total > 3) {
          $width = 50;
        }

        navigation.find("li").css("width", $width + "%");
        $first_li = navigation.find("li:first-child a").html();
        $moving_div = $('<div class="moving-tab">' + $first_li + "</div>");
        $(".wizard-card .wizard-navigation").append($moving_div);
        refreshAnimation($wizard, index);
        $(".moving-tab").css("transition", "transform 0s");
      },

      onTabClick: function(tab, navigation, index) {
        var $valid1 = $(".wizard-card #register-step1").valid();
        var $valid2 = $(".wizard-card #register-step-last").valid();

        if (!$valid1 || !$valid2) {
          return false;
        } else {
          if ($(".wizard-card").bootstrapWizard("currentIndex") == 0)
            $("#register-step1").submit();

          return true;
        }
      },

      onTabShow: function(tab, navigation, index) {
        var $total = navigation.find("li").length;
        var $current = index + 1;

        var $wizard = navigation.closest(".wizard-card");
        if ($current == 2) {
          $(".btn-next.btn-fill").val("Next");
        }
        // If it's the last tab then hide the last button and show the finish instead
        if ($current >= $total) {
          $($wizard)
            .find(".btn-next")
            .hide();
          $($wizard)
            .find(".btn-finish")
            .show();
        } else {
          $($wizard)
            .find(".btn-next")
            .show();
          $($wizard)
            .find(".btn-finish")
            .hide();
        }

        button_text = navigation
          .find("li:nth-child(" + $current + ") a")
          .html();

        setTimeout(function() {
          $(".moving-tab").text(button_text);
        }, 150);

        var checkbox = $(".footer-checkbox");

        if (!index == 0) {
          $(checkbox).css({
            opacity: "0",
            visibility: "hidden",
            position: "absolute"
          });
        } else {
          $(checkbox).css({
            opacity: "1",
            visibility: "visible"
          });
        }

        refreshAnimation($wizard, index);
      }
    });

    // Prepare the preview for profile picture
    $("#wizard-picture").change(function() {
      readURL(this);
    });

    $('[data-toggle="wizard-radio"]').click(function() {
      wizard = $(this).closest(".wizard-card");
      wizard.find('[data-toggle="wizard-radio"]').removeClass("active");
      $(this).addClass("active");
      $(wizard)
        .find('[type="radio"]')
        .removeAttr("checked");
      $(this)
        .find('[type="radio"]')
        .attr("checked", "true");
    });

    $('[data-toggle="wizard-checkbox"]').click(function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
          .find('[type="checkbox"]')
          .removeAttr("checked");
      } else {
        $(this).addClass("active");
        $(this)
          .find('[type="checkbox"]')
          .attr("checked", "true");
      }
    });

    $(".set-full-height").css("height", "auto");
  }

  if ($(".wizard-card #form-phase1").length) {
    var $validator3 = $(".wizard-card #form-phase1").validate({
      rules: {
        date: {
          required: true,
          minlength: 3
        },
        name: {
          required: true,
          minlength: 3
        },
        surname: {
          required: true,
          minlength: 3
        },
        phone: {
          required: true,
          minlength: 9
        },
        email: {
          required: true
        },
        price: {
          required: true
        }
      }
    });
    $display_width = $(document).width();

    if ($display_width <= 767) {
      $(".about_text").text(function() {
        return "1";
      });

      $(".add_act_text").text(function() {
        return "2";
      });

      $(".in_progress_text").text(function() {
        return "3";
      });
    }
    $(".wizard-card").bootstrapWizard({
      tabClass: "nav nav-pills",
      nextSelector: ".btn-next",
      lastSelector: ".btn-finish",
      previousSelector: ".btn-previous",
      skipSelector: ".btn-skip",
      onPrevious: function(tab, navigation, index){
        $('#response_text_success').hide();
        $('#response_text_error').hide();
        $('#promo_code').val('');
        $('#enter_promo').prop('disabled', true);
        $('#promo_code').prop('readonly', false);
        $('.promo-code-details').attr('name', 'remove');
        $('#remove_promo_code').hide();
        console.log($('.promo-code-detail'));
        updatePrice();
      },
      onNext: function(tab, navigation, index) {
        if (index == 1) {
          var $valid = $(".wizard-card #form-phase1").valid();
          if (!$valid) {
            $validator3.focusInvalid();
            return false;
          } else {
            $("html, body").animate(
              {
                scrollTop: $("#rootwizard").offset().top
              },
              1000
            );
        var current_bookable_extras = 0;

            $.each($('input[name="bookable_extra[]"]:checked'), function(input_key, input) {
              var bookable_extra_price = input.id;
              bookable_extra_price = bookable_extra_price.replace('extra_' + input.value + '_', "");
              current_bookable_extras = parseInt(current_bookable_extras) + parseInt(bookable_extra_price);
            })
            var sum = parseInt($('#select-price').find(":selected").attr("data-price"))+parseInt($('#summary-county-price').attr("data-price")) + parseInt($('#summary-late-packup-price').attr("data-price")) + parseInt($('#summary-early-setup-price').attr("data-price")) + parseInt(current_bookable_extras);
              $("#overview-price").html($("#total-price").html());
              price = parseInt(
                $("#total-price")
                  .html()
                  .split("£")[1]
              );
              date = moment($("#overview-date").html(), "DD/MM/YYYY").subtract(
                3,
                "weeks"
              );
            if ($("#book_type").val() == "book") {
              if($('input[type=radio][name=pay_type]').val() == 'partial'){
                $('#balance-due').remove();
                $("#overview-price").html("&pound;" + precisionRound((0.2*sum)+5,2));
                $("<p id='balance-due'>Balance of &pound;"+ precisionRound((0.8*sum),2) +" will be due on "+date.format("DD/MM/YYYY")+"</p>").insertAfter('#overview-price');
              }else if($('input[type=radio][name=pay_type]').val() == 'full'){
                $('#balance-due').remove();
                $("#overview-price").html("&pound;" + precisionRound(sum+5,2));
              }
              $("#20-total").html("&pound" + precisionRound((0.2*sum)+5,2));
              $("#80-total").html("&pound" + precisionRound((0.8*sum),2));
              $("#100-total").html("&pound" + (sum+5));
              $("#due-date-total").html(date.format("DD/MM/YYYY"));
            } else {
              $("#overview-price").html("&pound;15");
            }
            $("#overview-name").html($('input[name="name"]').val());
            $("#overview-surname").html($('input[name="surname"]').val());
            $("#overview-email").html($('input[name="email"]').val());
            $("#overview-VAT").html($('input[name="VAT"]').val());
            $("#overview-company_name").html($('input[name="company_name"]').val());
            $("#overview-phone").html($('input[name="phone"]').val());
            $("#overview-notes").html($("#textarea-notes").val());
            $("#overview-notes-mobile").html($("#textarea-notes").val());
            $("#overview-start-time").html($('input[name="start_time"]').val());
            // $("#overview-finish-time").html($('input[name="finish_time"]').val());
            $("#overview-personal-address").html(
              $('input[name="client_address"]').val()
            );
            $("#overview-address-2").html(
              $('input[name="client_address_2"]').val()
            );
            $("#overview-address-3").html(
              $('input[name="client_address_3"]').val()
            );

            $("#overview-office-phone").html(
              $('input[name="home_phone"]').val()
            );
            $("#overview-city-town").html($('input[name="city_town"]').val());
            $("#overview-country").html($('input[name="country"]').val());
            $("#overview-postcode").html($('input[name="postcode"]').val());

            $("#overview-venue-address-1").html(
              $('input[name="venue_address_1"]').val()
            );
            $("#overview-venue-address-2").html(
              $('input[name="venue_address_2"]').val()
            );
            $("#overview-venue-address-3").html(
              $('input[name="venue_address_3"]').val()
            );
            $("#overview-venue-postcode").html(
              $('input[name="venue_postcode"]').val()
            );
            $("#overview-venue-city").html($('input[name="venue_city"]').val());
            $("#overview-emergency-phone").html(
              $('input[name="emergency_phone"]').val()
            );
            $("#overview-venue-phone").html(
              $('input[name="venue_contact"]').val()
            );

            if ($('input[name="guests"]').val() == "") {
              $("#overview-guests").html(0);
            } else {
              $("#overview-guests").html($('input[name="guests"]').val());
            }

            if ($('input[name="bookable_extra[]"]:checked').length > 0) {
              $.each($('input[name="bookable_extra[]"]:checked'), function(
                input_key,
                input
              ) {
                var overview_book_extra = $(
                  ".overview-bookable-extras-clone"
                ).clone();
                overview_book_extra.insertBefore(".overview_county");
                overview_book_extra.attr("id", "overview_" + input.id);
                overview_book_extra.addClass("overview-bookable-extras");
                $(".overview-bookable-extras").removeClass(
                  "overview-bookable-extras-clone"
                );
                $("#overview_" + input.id).css("margin-left", "20px");
                var name = $("label[for='" + input.id + "']").text();
                name = name.replace("Add ", "");
                var toReplace = input.id.replace(
                  "extra_" + input.value + "_",
                  ""
                );
                name = name.replace(" for \u00A3 " + toReplace, "");
                $("#overview_" + input.id)
                  .find("#bookable_extra_name_overview")
                  .text("+ " + name);
                $("#overview_" + input.id).show();
              });
            }
          }
        }
      },

      onLast: function(tab, navigation, index) {
        $($wizard)
          .find(".btn-previous")
          .hide();
        $($wizard)
          .find(".btn-next")
          .hide();
        $($wizard)
          .find(".btn-finish")
          .hide();
      },

      onInit: function(tab, navigation, index) {
        //check number of tabs and fill the entire row
        var $total = navigation.find("li").length;
        $width = 100 / $total;
        var $wizard = navigation.closest(".wizard-card");

        if ($display_width < 600 && $total > 3) {
          $width = 50;
        }

        navigation.find("li").css("width", $width + "%");
        $first_li = navigation.find("li:first-child a").html();
        $moving_div = $('<div class="moving-tab">' + $first_li + "</div>");
        $(".wizard-card .wizard-navigation").append($moving_div);
        refreshAnimation($wizard, index);
        $(".moving-tab").css("transition", "transform 0s");
      },

      onTabClick: function(tab, navigation, index) {
        return false;
      },

      onTabShow: function(tab, navigation, index) {
        var $total = navigation.find("li").length;
        var $current = index + 1;

        var $wizard = navigation.closest(".wizard-card");
        if ($current == 2) {
          $(".btn-next.btn-fill").val("Next");
        }
        // If it's the last tab then hide the last button and show the finish instead
        if ($current >= $total) {
          $($wizard)
            .find(".btn-next")
            .hide();
          $($wizard)
            .find(".btn-finish")
            .show();
          $($wizard)
            .find(".btn-stripe")
            .hide();
        } else if ($current >= $total - 1) {
          $($wizard)
            .find(".btn-next")
            .hide();
          $($wizard)
            .find(".btn-stripe")
            .show();
        } else {
          $($wizard)
            .find(".btn-next")
            .show();
          $($wizard)
            .find(".btn-finish")
            .hide();
          $($wizard)
            .find(".btn-stripe")
            .hide();
        }
        if ($current == 3) {
          $($wizard)
            .find(".btn-previous")
            .hide();
          $($wizard)
            .find(".btn-next")
            .hide();
          $($wizard)
            .find(".btn-finish")
            .hide();
        }

        button_text = navigation
          .find("li:nth-child(" + $current + ") a")
          .html();

        setTimeout(function() {
          $(".moving-tab").text(button_text);
        }, 150);

        var checkbox = $(".footer-checkbox");

        if (!index == 0) {
          $(checkbox).css({
            opacity: "0",
            visibility: "hidden",
            position: "absolute"
          });
        } else {
          $(checkbox).css({
            opacity: "1",
            visibility: "visible"
          });
        }

        refreshAnimation($wizard, index);
      }
    });
  }
});

//Function to show image before upload

function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function(e) {
      $("#wizardPicturePreview")
        .attr("src", e.target.result)
        .fadeIn("slow");
    };
    reader.readAsDataURL(input.files[0]);
  }
}

$(window).resize(function() {
  $(".wizard-card").each(function() {
    $wizard = $(this);
    index = $wizard.bootstrapWizard("currentIndex");
    refreshAnimation($wizard, index);

    $(".moving-tab").css({
      transition: "transform 0s"
    });
  });
});

function refreshAnimation($wizard, index) {
  total_steps = $wizard.find("li").length;
  move_distance = $wizard.width() / total_steps;
  step_width = move_distance;
  move_distance *= index;

  $wizard.find(".moving-tab").css("width", step_width);
  $(".moving-tab").css({
    height: "100%",
    padding: "18px 0",
    transform: "translate3d(" + move_distance + "px, 0, 0)",
    transition: "all 0.3s ease-out"
  });
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}
